import * as React from 'react';

import type { HiveWorkingBranch } from '@gitbook/hive-client';
import type * as hiveCore from '@gitbook/hive-core';

/**
 * Get the current content operation on a branch and subscribe to updates.
 */
export function useHiveBranchOperation(
    sync: HiveWorkingBranch | null | undefined
): hiveCore.ContentOperation | null {
    const subscription = React.useMemo(() => {
        if (!sync) {
            return {
                getCurrentValue: () => {
                    return null;
                },
                subscribe: () => {
                    return () => {};
                },
            };
        }

        return {
            getCurrentValue: () => {
                return sync.dataSync.operation;
            },
            subscribe: (callback) => {
                return sync.dataSync.listen('operation', callback);
            },
        };
    }, [sync?.dataSync, sync?.contentId, sync?.branchId]);

    return React.useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue);
}
